exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.lxm-org-item__right-arrow[data-v-247fd126] {\n  width: 0.5rem;\n  height: 0.857142857142857rem;\n}\n", "", {"version":3,"sources":["/./src/components/Main/common/src/components/Main/common/LxmOrgItem.vue","/./src/components/Main/common/LxmOrgItem.vue"],"names":[],"mappings":";AAQA;EACE,cAAA;EACA,6BAAA;CCPD","file":"LxmOrgItem.vue","sourcesContent":["\n\n\n\n\n\n\n@import '../../styles/variables.styl'\n.lxm-org-item__right-arrow\n  width: siz(7)\n  height: siz(12)\n",".lxm-org-item__right-arrow {\n  width: 0.5rem;\n  height: 0.857142857142857rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=data-v-247fd126&scoped=true!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Main/common/LxmOrgItem.vue
// module id = 609
// module chunks = 0